import { render, staticRenderFns } from "./citiesAutocomplete.vue?vue&type=template&id=af601c08&"
import script from "./citiesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./citiesAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports